import React, { createContext, useContext, ReactNode } from 'react';
import type { DashboardPage } from './DashboardContainerStub';

interface OptimizerNavContextValue {
  onNavigate: (page: DashboardPage) => void;
}

const OptimizerNavContext = createContext<OptimizerNavContextValue | null>(null);

export function OptimizerNavProvider({
  onNavigate,
  children,
}: {
  onNavigate: (page: DashboardPage) => void;
  children: ReactNode;
}) {
  return (
    <OptimizerNavContext.Provider value={{ onNavigate }}>
      {children}
    </OptimizerNavContext.Provider>
  );
}

export function useOptimizerNav(): OptimizerNavContextValue | null {
  return useContext(OptimizerNavContext);
}
